export const DIFFICULTY = ['Simple', 'Standard', 'Advanced'];